/**
 * 對齊 docs/05-技術棧架構.md §10.3 RBAC
 * 第一版單角色；之後若擴為多角色，user_roles 多對多關係。
 */
export const Role = {
  ADMIN: 'ADMIN',
  SALES: 'SALES',
  VIEWER: 'VIEWER',
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export const ROLE_VALUES = Object.values(Role);
